export default [
  {
    path: 'M453.86 107.12S531.73 47 665.64 90.72c0 0 45.09 16.4 97 62.85L923.88 323l-86.08 86.07L591.85 159s-41-50.55-138-51.92z m355.25 332L708 537.5s-16.4 23.23-30.06 1.37L492.11 357.15s-16.4-21.86-28.69-2.73L276.23 545.7s-12.3 19.13 2.77 27.3l183.05 183.11s15 24.59 28.69 5.46l189.93-191.28s5.46-16.4 35.52-12.3h194s8.2 196.75-142.1 319.72c0 0-195.39 195.38-463.19 75.15 0 0-258.24-90.18-255.51-424.92 0 0 6.83-224.07 210.42-342.94 0 0 148.93-110.67 267.8-28.69L809.1 439.13z',
    fill: '#003B90',
  },
]
